import { PermissionsEnum } from "@/auth/interfaces";
import SaveNodo from "../../shared/saveNodo/saveNodo";
import { useCheckPermissions } from "@/shared";

export interface CreateNodoPageInterface { }

const CreateNodoPage: React.FC<CreateNodoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_nodo)

  return <SaveNodo titlePage="Crear Nodo" enableUploadFile={true} />;
};

export default CreateNodoPage;
